import React, { useState } from "react";
import { LedChoice } from "../components/side/led_chiusure";
import { Side, SideSelector } from "../components/side/side_selector";

const ALL_SIDES: Side[] = ["front", "left", "back", "right"];

const LigthChoices: React.FC = () => {
  const [side, setSide] = useState<Side>("front");

  const sidesMap: Record<Side, JSX.Element> = {
    front: <LedChoice lato="Fronte"/>,
    left: <LedChoice lato='Sinistra'/>,
    right: <LedChoice lato='Destra'/>,
    back: <LedChoice lato='Retro'/>,
  };

  return (
    <div>
      <SideSelector sides={ALL_SIDES} value={side} onChange={setSide} />
      <div style={{ marginTop: 20 }}>
        {sidesMap[side]}
      </div>
    </div>
  );
};

export default LigthChoices;
